export const employerModalType = {
  None: 'none',
  EmployerInfo: 'employerInfo',
  AddressInfo: 'addressInfo',
  RemoveAgent: 'removeAgent',
  ConnectedTeams: 'connectedTeams',
};
